import React from 'react';


export type EditConnectionDialogPromptProps = Readonly<{
  prompt: string;
}>;

export function EditConnectionDialogPrompt(props: EditConnectionDialogPromptProps) {
  return (
    <>
      < div data-tb-test-id='edit-conn-prompt'>
        {props.prompt}
      </div >
    </>
  );
}
